// useSessionTokenBridge — persist the signed-in JWT to ~/.apolo/session-token (via IPC) so the
// daily-improve launchd cron can authenticate to /agent-turn + /api/models/refresh. Writes on
// mount and whenever the auth user changes (login); clears the file on logout (token null).
import { useEffect } from 'react';
import { getStoredToken } from '../lib/api.js';
import { useAuthStore } from '../store/useAuthStore.js';

export function useSessionTokenBridge() {
  const user = useAuthStore((s) => s.user);
  useEffect(() => {
    const w = /** @type {any} */ (typeof window !== 'undefined' ? window : {});
    try { w?.apolo?.session?.persistToken?.(getStoredToken() || null); } catch { /* not in Electron */ }
  }, [user]);
}
